export const accent = '#222';
export const hover = '#F91A5E';
